module.exports = __webpack_public_path__ + "static/media/img-05.fbed90b1.png";